import { useState } from 'react';
import { toast } from 'sonner';
import { useDeleteVerification } from '@/features/verifications/hooks/useDeleteVerification';

export interface VerificationDelete {
  deletingId: string | null;
  setDeletingId: (id: string | null) => void;
  confirmDelete: () => void;
}

export function useVerificationDelete(
  candidateId: string,
  experienceId: string
): VerificationDelete {
  const [deletingId, setDeletingId] = useState<string | null>(null);
  const { deleteVerification } = useDeleteVerification();

  const confirmDelete = (): void => {
    if (!deletingId) return;
    deleteVerification(
      { candidateId, experienceId, verificationId: deletingId },
      {
        onSuccess: () => {
          toast.success('Verification deleted');
          setDeletingId(null);
        },
        onError: () => toast.error('Failed to delete verification'),
      }
    );
  };

  return { deletingId, setDeletingId, confirmDelete };
}
